import { render } from "./FullPVT.vue?vue&type=template&id=15138f52"
import script from "./FullPVT.vue?vue&type=script&lang=js"
export * from "./FullPVT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__